package br.com.vvrefeicoes.portal.feature.rmp

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PlainTooltip
import androidx.compose.material3.PrimaryScrollableTabRow
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Tab
import androidx.compose.material3.Text
import androidx.compose.material3.TooltipBox
import androidx.compose.material3.TooltipDefaults
import androidx.compose.material3.rememberTooltipState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.di.rememberSessionPermissions
import br.com.vvrefeicoes.portal.core.ui.components.AppBadge
import br.com.vvrefeicoes.portal.core.ui.components.AppBanner
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.components.AppPagination
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppTooltipText
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.isFileExportSupported
import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import br.com.vvrefeicoes.portal.domain.model.PermissionKeys
import br.com.vvrefeicoes.portal.domain.model.RmpOverviewItem
import br.com.vvrefeicoes.portal.domain.model.RmpOverviewView
import br.com.vvrefeicoes.portal.domain.model.allows
import com.composables.icons.lucide.Check
import com.composables.icons.lucide.Download
import com.composables.icons.lucide.Eye
import com.composables.icons.lucide.FileCheck
import com.composables.icons.lucide.FileClock
import com.composables.icons.lucide.FileExclamationPoint
import com.composables.icons.lucide.FilePlus
import com.composables.icons.lucide.FileUser
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.RefreshCw
import com.composables.icons.lucide.Search
import com.composables.icons.lucide.SlidersHorizontal
import com.composables.icons.lucide.X
import kotlinx.datetime.UtcOffset
import kotlinx.datetime.asTimeZone
import kotlinx.datetime.toLocalDateTime
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.rmp_action_details
import portalvv.shared.generated.resources.rmp_approval_approve
import portalvv.shared.generated.resources.rmp_approval_attachments
import portalvv.shared.generated.resources.rmp_approval_reject
import portalvv.shared.generated.resources.rmp_attachment_not_copied
import portalvv.shared.generated.resources.rmp_card_finished
import portalvv.shared.generated.resources.rmp_card_in_progress
import portalvv.shared.generated.resources.rmp_card_my_pending
import portalvv.shared.generated.resources.rmp_card_total
import portalvv.shared.generated.resources.rmp_col_actions
import portalvv.shared.generated.resources.rmp_col_created_at
import portalvv.shared.generated.resources.rmp_col_id
import portalvv.shared.generated.resources.rmp_col_requester
import portalvv.shared.generated.resources.rmp_col_status
import portalvv.shared.generated.resources.rmp_col_type
import portalvv.shared.generated.resources.rmp_col_unit
import portalvv.shared.generated.resources.rmp_col_updated_at
import portalvv.shared.generated.resources.rmp_col_waiting
import portalvv.shared.generated.resources.rmp_details_email
import portalvv.shared.generated.resources.rmp_details_last_action
import portalvv.shared.generated.resources.rmp_details_title
import portalvv.shared.generated.resources.rmp_empty
import portalvv.shared.generated.resources.rmp_filter_my_pending
import portalvv.shared.generated.resources.rmp_request_new
import portalvv.shared.generated.resources.rmp_retry
import portalvv.shared.generated.resources.rmp_search
import portalvv.shared.generated.resources.rmp_sync
import portalvv.shared.generated.resources.rmp_sync_result
import portalvv.shared.generated.resources.rmp_syncing
import portalvv.shared.generated.resources.rmp_tab_in_progress
import portalvv.shared.generated.resources.rmp_tab_unit_history
import portalvv.shared.generated.resources.rmp_tab_user_history
import portalvv.shared.generated.resources.rmp_title
import portalvv.shared.generated.resources.rmp_type_alteracao
import portalvv.shared.generated.resources.rmp_type_desligamento
import portalvv.shared.generated.resources.rmp_type_gratificacao
import portalvv.shared.generated.resources.rmp_type_requisicao
import portalvv.shared.generated.resources.rmp_type_requisicao_teste
import portalvv.shared.generated.resources.rmp_type_termino_contrato
import portalvv.shared.generated.resources.rmp_type_transferencia
import portalvv.shared.generated.resources.rmp_unit_rules
import kotlin.time.Instant

private val WeightId = 0.6f
private val WeightType = 1.5f
private val WeightStatus = 1.3f
private val WeightRequester = 1.7f
private val WeightUnit = 1.6f
private val WeightWaiting = 1.9f
private val WeightCreatedAt = 1.3f
private val WeightUpdatedAt = 1.3f
private val WeightActions = 1.0f

/** Abaixo desta largura a tabela rola na horizontal em vez de espremer as colunas. */
private val TableMinWidth = 1200.dp

// Mesmo fuso fixo do backend (America/Manaus): não depende da base de fusos opcional do navegador no Wasm.
private val BusinessTimeZone = UtcOffset(hours = -4).asTimeZone()

internal val RmpTypes =
    listOf(
        "requisicao",
        "alteracao",
        "desligamento",
        "termino_contrato",
        "transferencia",
        "gratificacao",
        "requisicao_teste",
    )

private const val EMPTY_VALUE = "-"

@Composable
fun RmpScreen(
    onRequestNew: () -> Unit,
    onEdit: (String) -> Unit,
) {
    val controller = rememberRmpController()
    val permissions = rememberSessionPermissions()
    // A API exige a ação de criação para disparar a sincronização (POST /rmp/sync).
    val canSync = permissions.allows(PermissionKeys.RMP, PermissionAction.CREATE)
    val canRequest = PermissionKeys.RMP_REQUEST in permissions
    val canManageRules = PermissionKeys.RMP_ADMIN in permissions
    var showUnitRules by remember { mutableStateOf(false) }

    LaunchedEffect(controller) {
        controller.init()
    }

    AppScrollColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(AppSpacing.space24),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        footer = { AppFooter() },
    ) {
        Text(
            text = stringResource(Res.string.rmp_title),
            style = MaterialTheme.typography.headlineMedium,
        )

        SummaryCards(controller)

        controller.errorMessage?.let { message ->
            Surface(
                modifier = Modifier.fillMaxWidth(),
                color = MaterialTheme.colorScheme.errorContainer,
                shape = AppShapes.medium,
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    Text(
                        text = message,
                        color = MaterialTheme.colorScheme.onErrorContainer,
                        modifier = Modifier.weight(1f),
                    )
                    AppButton(
                        text = stringResource(Res.string.rmp_retry),
                        onClick = controller::retry,
                        variant = PortalButtonVariant.Outlined,
                    )
                }
            }
        }

        controller.syncResult?.let { result ->
            AppBanner(
                text =
                    stringResource(
                        Res.string.rmp_sync_result,
                        result.total,
                        result.created,
                        result.updated,
                        result.deleted,
                        result.failed,
                    ),
                onDismiss = controller::dismissSyncFeedback,
                isError = result.failed > 0,
            )
        }

        controller.syncError?.let { message ->
            AppBanner(text = message, onDismiss = controller::dismissSyncFeedback, isError = true)
        }

        controller.exportError?.let { message ->
            AppBanner(text = message, onDismiss = controller::dismissExportError, isError = true)
        }

        ViewTabs(controller)

        SearchAndFilters(controller)

        RmpFiltersBar(controller)

        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12, Alignment.End),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            if (canManageRules && controller.requestsEnabled) {
                AppButton(
                    text = stringResource(Res.string.rmp_unit_rules),
                    onClick = { showUnitRules = true },
                    variant = PortalButtonVariant.Text,
                    leadingIcon = Lucide.SlidersHorizontal,
                )
            }
            if (canSync) {
                AppButton(
                    text = stringResource(if (controller.syncing) Res.string.rmp_syncing else Res.string.rmp_sync),
                    onClick = controller::sync,
                    enabled = !controller.syncing,
                    variant = PortalButtonVariant.Text,
                    leadingIcon = Lucide.RefreshCw,
                )
            }
            if (isFileExportSupported()) {
                RmpExportMenu(controller)
            }
            if (canRequest && controller.requestsEnabled) {
                AppButton(
                    text = stringResource(Res.string.rmp_request_new),
                    onClick = onRequestNew,
                    variant = PortalButtonVariant.Filled,
                    leadingIcon = Lucide.FilePlus,
                )
            }
        }

        if (controller.loading) {
            Box(
                modifier = Modifier.fillMaxWidth().height(240.dp),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator()
            }
        } else {
            RmpTable(controller)
            AppPagination(
                page = controller.page,
                pageCount = controller.pageCount,
                onPageChange = controller::goToPage,
            )
        }
    }

    controller.detailsItem?.let { item ->
        if (item.isPortal) {
            RmpApprovalDialog(
                item = item,
                onDismiss = controller::dismissDetails,
                onDecided = controller::refresh,
                onEdit = { id ->
                    controller.dismissDetails()
                    onEdit(id)
                },
            )
        } else {
            RmpDetailsDialog(item = item, controller = controller)
        }
    }
    if (showUnitRules) {
        RmpUnitRulesDialog(onDismiss = { showUnitRules = false })
    }
    controller.decisionItem?.let { item ->
        RmpDecisionDialog(
            item = item,
            approve = controller.decisionApprove,
            onDismiss = controller::dismissDecision,
            onDecided = {
                controller.dismissDecision()
                controller.refresh()
            },
            onEdit = { id ->
                controller.dismissDecision()
                // Na transferência o que falta é o checklist, que fica no detalhe; nos outros tipos, o formulário.
                if (item.type == "transferencia") controller.openDetails(item) else onEdit(id)
            },
        )
    }
}

@Composable
private fun SummaryCards(controller: RmpController) {
    val summary = controller.summary
    val cards =
        listOf(
            SummaryCardData(Res.string.rmp_card_total, summary.total, Lucide.FileUser, AppPalette.Info100, AppPalette.Info900),
            SummaryCardData(Res.string.rmp_card_finished, summary.finished, Lucide.FileCheck, AppPalette.Success100, AppPalette.Success900),
            SummaryCardData(Res.string.rmp_card_in_progress, summary.inProgress, Lucide.FileClock, AppPalette.Warning100, AppPalette.Warning900),
            SummaryCardData(
                Res.string.rmp_card_my_pending,
                summary.myPending,
                Lucide.FileExclamationPoint,
                AppPalette.Error100,
                AppPalette.Error900,
            ),
        )
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val columns =
            when {
                maxWidth < 560.dp -> 1
                maxWidth < 1000.dp -> 2
                else -> 4
            }
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
            cards.chunked(columns).forEach { row ->
                Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
                    row.forEach { card -> SummaryCard(card, Modifier.weight(1f)) }
                    repeat(columns - row.size) { Box(modifier = Modifier.weight(1f)) }
                }
            }
        }
    }
}

private data class SummaryCardData(
    val label: org.jetbrains.compose.resources.StringResource,
    val value: Long,
    val icon: ImageVector,
    val iconBackground: Color,
    val iconTint: Color,
)

@Composable
private fun SummaryCard(
    card: SummaryCardData,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier,
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        ) {
            Surface(shape = AppShapes.medium, color = card.iconBackground, modifier = Modifier.size(48.dp)) {
                Box(contentAlignment = Alignment.Center) {
                    Icon(card.icon, contentDescription = null, tint = card.iconTint, modifier = Modifier.size(28.dp))
                }
            }
            Column {
                Text(
                    text = stringResource(card.label),
                    style = MaterialTheme.typography.labelMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = card.value.toString(),
                    style = MaterialTheme.typography.headlineMedium,
                    fontWeight = FontWeight.Bold,
                    color = MaterialTheme.colorScheme.onSurface,
                )
            }
        }
    }
}

/** Em andamento (onde se aprova) × concluídos das minhas unidades × o que eu decidi, mesmo fora delas. */
@Composable
private fun ViewTabs(controller: RmpController) {
    PrimaryScrollableTabRow(selectedTabIndex = controller.view.ordinal) {
        RmpOverviewView.entries.forEach { view ->
            val label =
                when (view) {
                    RmpOverviewView.ANDAMENTO -> stringResource(Res.string.rmp_tab_in_progress)
                    RmpOverviewView.UNIDADE -> stringResource(Res.string.rmp_tab_unit_history)
                    RmpOverviewView.USUARIO -> stringResource(Res.string.rmp_tab_user_history)
                }
            Tab(
                selected = view == controller.view,
                onClick = { controller.updateView(view) },
                text = { Text(text = label) },
            )
        }
    }
}

@Composable
private fun SearchAndFilters(controller: RmpController) {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val search =
            @Composable { modifier: Modifier ->
                AppTextField(
                    value = controller.query,
                    onValueChange = controller::updateQuery,
                    placeholder = stringResource(Res.string.rmp_search),
                    leadingIcon = { Icon(Lucide.Search, contentDescription = null) },
                    modifier = modifier,
                )
            }
        // Pendências só existem entre os RMPs em andamento.
        val toggles =
            @Composable {
                if (controller.view == RmpOverviewView.ANDAMENTO) {
                    FilterSwitch(
                        label = stringResource(Res.string.rmp_filter_my_pending),
                        checked = controller.myPendingOnly,
                        onCheckedChange = controller::updateMyPendingOnly,
                    )
                }
            }
        if (maxWidth < 720.dp) {
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                search(Modifier.fillMaxWidth())
                Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16)) { toggles() }
            }
        } else {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            ) {
                search(Modifier.weight(1f))
                toggles()
            }
        }
    }
}

@Composable
private fun FilterSwitch(
    label: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Switch(checked = checked, onCheckedChange = onCheckedChange)
    }
}

@Composable
private fun RmpTable(controller: RmpController) {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val tableWidth = if (maxWidth < TableMinWidth) TableMinWidth else maxWidth
        Box(modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState())) {
            Surface(
                modifier = Modifier.width(tableWidth),
                shape = AppShapes.large,
                color = MaterialTheme.colorScheme.surface,
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
            ) {
                Column(modifier = Modifier.fillMaxWidth()) {
                    RmpHeaderRow()
                    HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                    if (controller.items.isEmpty()) {
                        EmptyState(message = stringResource(Res.string.rmp_empty))
                    } else {
                        controller.items.forEachIndexed { index, item ->
                            RmpRow(
                                item = item,
                                onDetails = { controller.openDetails(item) },
                                onDecide = { approve -> controller.openDecision(item, approve) },
                            )
                            if (index < controller.items.lastIndex) {
                                HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun RmpHeaderRow() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        HeaderCell(stringResource(Res.string.rmp_col_id), WeightId)
        HeaderCell(stringResource(Res.string.rmp_col_type), WeightType)
        HeaderCell(stringResource(Res.string.rmp_col_status), WeightStatus)
        HeaderCell(stringResource(Res.string.rmp_col_requester), WeightRequester)
        HeaderCell(stringResource(Res.string.rmp_col_unit), WeightUnit)
        HeaderCell(stringResource(Res.string.rmp_col_waiting), WeightWaiting)
        HeaderCell(stringResource(Res.string.rmp_col_created_at), WeightCreatedAt)
        HeaderCell(stringResource(Res.string.rmp_col_updated_at), WeightUpdatedAt)
        HeaderCell(stringResource(Res.string.rmp_col_actions), WeightActions)
    }
}

@Composable
private fun RowScope.HeaderCell(
    text: String,
    weight: Float,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = Modifier.weight(weight),
    )
}

@Composable
private fun RmpRow(
    item: RmpOverviewItem,
    onDetails: () -> Unit,
    onDecide: (approve: Boolean) -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        BodyCell(item.code, WeightId)
        BodyCell(typeText(item), WeightType)
        Box(modifier = Modifier.weight(WeightStatus), contentAlignment = Alignment.CenterStart) { StatusBadge(item) }
        BodyCell(requesterText(item).orDash(), WeightRequester)
        TwoLineCell(item.unitName.orDash(), actorText(item), WeightUnit)
        WaitingCell(item, WeightWaiting)
        BodyCell(formatBusinessDateTime(item.createdAt).orDash(), WeightCreatedAt)
        BodyCell(formatBusinessDateTime(item.updatedAt).orDash(), WeightUpdatedAt)
        Row(
            modifier = Modifier.weight(WeightActions),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space4, Alignment.Start),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            RmpActionButton(Lucide.Eye, stringResource(Res.string.rmp_action_details), MaterialTheme.colorScheme.onSurfaceVariant, onDetails)
            // Aprovar/Rejeitar só para RMPs do portal cuja etapa atual o usuário decide (a API calcula myPending).
            if (item.isPortal && item.myPending) {
                RmpActionButton(Lucide.Check, stringResource(Res.string.rmp_approval_approve), AppPalette.Success900) { onDecide(true) }
                RmpActionButton(Lucide.X, stringResource(Res.string.rmp_approval_reject), MaterialTheme.colorScheme.error) { onDecide(false) }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun RmpActionButton(
    icon: ImageVector,
    label: String,
    tint: Color,
    onClick: () -> Unit,
) {
    TooltipBox(
        positionProvider = TooltipDefaults.rememberPlainTooltipPositionProvider(),
        tooltip = { PlainTooltip { Text(label) } },
        state = rememberTooltipState(),
    ) {
        IconButton(onClick = onClick, modifier = Modifier.size(28.dp)) {
            Icon(imageVector = icon, contentDescription = label, tint = tint, modifier = Modifier.size(18.dp))
        }
    }
}

@Composable
private fun RowScope.BodyCell(
    text: String,
    weight: Float,
) {
    Box(modifier = Modifier.weight(weight), contentAlignment = Alignment.CenterStart) {
        AppTooltipText(
            text = text,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
    }
}

@Composable
private fun RmpDetailsDialog(
    item: RmpOverviewItem,
    controller: RmpController,
) {
    AppModalCard(
        title = stringResource(Res.string.rmp_details_title),
        onDismiss = controller::dismissDetails,
    ) {
        DetailRow(stringResource(Res.string.rmp_col_id), item.code)
        DetailRow(stringResource(Res.string.rmp_col_type), typeText(item))
        DetailRow(stringResource(Res.string.rmp_col_status), statusText(item))
        DetailRow(
            stringResource(Res.string.rmp_col_requester),
            requesterText(item).orDash(),
        )
        DetailRow(stringResource(Res.string.rmp_details_email), item.requesterEmail.orDash())
        DetailRow(stringResource(Res.string.rmp_col_unit), item.unitName.orDash())
        DetailRow(stringResource(Res.string.rmp_details_last_action), actorText(item).orDash())
        DetailRow(
            stringResource(Res.string.rmp_col_waiting),
            listOfNotNull(item.waitingStageLabel, item.waitingName).joinToString(" · ").orDash(),
        )
        DetailRow(stringResource(Res.string.rmp_col_created_at), formatBusinessDateTime(item.createdAt).orDash())
        DetailRow(stringResource(Res.string.rmp_col_updated_at), formatBusinessDateTime(item.updatedAt).orDash())
        RequiredActions(item)
        LegacyAttachments(controller)
    }
}

/** Anexos do RMP antigo: baixados do S3 do portal; os que ainda não foram copiados aparecem desabilitados. */
@Composable
private fun LegacyAttachments(controller: RmpController) {
    val attachments = controller.detailsAttachments
    if (!controller.detailsAttachmentsLoading && attachments.isEmpty() && controller.detailsAttachmentsError == null) return
    HorizontalDivider()
    Text(text = stringResource(Res.string.rmp_approval_attachments), style = MaterialTheme.typography.titleMedium)
    if (controller.detailsAttachmentsLoading) {
        CircularProgressIndicator(modifier = Modifier.size(24.dp))
    }
    attachments.forEach { attachment ->
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(
                text = legacyAttachmentLabel(attachment.field),
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            AppButton(
                text = attachment.fileName,
                onClick = { controller.downloadAttachment(attachment) },
                enabled = attachment.available,
                variant = PortalButtonVariant.Text,
                leadingIcon = Lucide.Download,
            )
            if (!attachment.available) {
                Text(
                    text = stringResource(Res.string.rmp_attachment_not_copied),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
        }
    }
    controller.detailsAttachmentsError?.let { message ->
        Text(text = message, style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.error)
    }
}

/** Nome do campo do RMP antigo onde o anexo apareceu (ex.: `dados.carta_desligamento_url`). */
internal fun legacyAttachmentLabel(field: String): String =
    when (field.substringAfterLast('.')) {
        "simulacao_rescisao_url" -> "Simulação de rescisão"
        "carta_desligamento_url" -> "Carta de desligamento"
        "documentos_substituicao_urls" -> "Documentos de substituição"
        "transferencia_anexo_url" -> "Anexo da transferência"
        "arquivo_aso_url", "arquivos_aso" -> "ASO"
        "arquivo_assinatura_funcionario_url", "arquivos_assinatura_funcionario" -> "Assinatura do funcionário"
        else -> field
    }

@Composable
internal fun DetailRow(
    label: String,
    value: String,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Text(
            text = value,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
    }
}

@Composable
private fun typeText(item: RmpOverviewItem): String = item.typeLabel ?: item.type?.let { typeLabel(it) }.orDash()

private fun statusText(item: RmpOverviewItem): String = (item.statusLabel ?: item.status).orDash()

@Composable
private fun StatusBadge(item: RmpOverviewItem) {
    val status =
        item.status
            ?.trim()
            ?.lowercase()
            .orEmpty()
    val (container, content) =
        when {
            status in FinishedStatuses -> AppPalette.Success100 to AppPalette.Success900
            status.startsWith("rejeitado") -> AppPalette.Error100 to AppPalette.Error900
            status == "pendente" -> AppPalette.Warning100 to AppPalette.Warning900
            status == "aprovado" || status == "aguardando_resultado_teste" -> AppPalette.Info100 to AppPalette.Info900
            else -> AppPalette.Neutral200 to AppPalette.Neutral900
        }
    AppBadge(text = statusText(item), containerColor = container, contentColor = content)
}

/** "Nome · Etapa" de quem fez a última ação (aprovou, rejeitou ou concluiu), ou null se ninguém agiu ainda. */
private fun actorText(item: RmpOverviewItem): String? = item.actorName?.let { name -> listOfNotNull(name, item.actorStageLabel).joinToString(" · ") }

/** "Nome - Função" de quem solicitou (ex.: "Filipe - Gerente de Unidade"); sem função, só o nome. */
private fun requesterText(item: RmpOverviewItem): String? = item.requesterName?.let { name -> listOfNotNull(name, item.requesterRole).joinToString(" - ") }

/** Texto principal e, embaixo, um complemento menor (na coluna Unidade, quem fez a última ação no RMP). */
@Composable
private fun RowScope.TwoLineCell(
    text: String,
    detail: String?,
    weight: Float,
) {
    if (detail == null) {
        BodyCell(text, weight)
        return
    }
    Column(modifier = Modifier.weight(weight), horizontalAlignment = Alignment.Start) {
        AppTooltipText(
            text = text,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
        AppTooltipText(
            text = detail,
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

/** Quem precisa agir agora (nome) e em qual etapa; sem o nome (ex.: RMP aberto no portal), só a etapa. */
@Composable
private fun RowScope.WaitingCell(
    item: RmpOverviewItem,
    weight: Float,
) {
    val name = item.waitingName
    val stage = item.waitingStageLabel
    if (name == null || stage == null) {
        BodyCell((name ?: stage).orDash(), weight)
        return
    }
    Column(modifier = Modifier.weight(weight), horizontalAlignment = Alignment.Start) {
        AppTooltipText(
            text = name,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
        Text(
            text = stage,
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
        )
    }
}

// Mesmos status "finalizados" do backend (inclui os erros de digitação vindos da RMP).
private val FinishedStatuses = setOf("concluido", "finalizado", "conlcuido", "concludio")

/** Instant ISO da API → "dd/MM/aaaa às HH:mm" no fuso do negócio. */
internal fun formatBusinessDateTime(value: String?): String? {
    val instant = value?.let { runCatching { Instant.parse(it) }.getOrNull() } ?: return null
    val local = instant.toLocalDateTime(BusinessTimeZone)

    fun two(number: Int) = number.toString().padStart(2, '0')
    return "${two(local.day)}/${two(local.month.ordinal + 1)}/${local.year} às ${two(local.hour)}:${two(local.minute)}"
}

@Composable
internal fun typeLabel(type: String): String =
    when (type) {
        "requisicao" -> stringResource(Res.string.rmp_type_requisicao)
        "alteracao" -> stringResource(Res.string.rmp_type_alteracao)
        "desligamento" -> stringResource(Res.string.rmp_type_desligamento)
        "termino_contrato" -> stringResource(Res.string.rmp_type_termino_contrato)
        "transferencia" -> stringResource(Res.string.rmp_type_transferencia)
        "gratificacao" -> stringResource(Res.string.rmp_type_gratificacao)
        "requisicao_teste" -> stringResource(Res.string.rmp_type_requisicao_teste)
        else -> type
    }

private fun String?.orDash(): String = if (isNullOrBlank()) EMPTY_VALUE else this
